import React, {useState, useEffect, useContext, useRef } from 'react';
import { IonModal, IonGrid, IonRow, IonCol, IonButton, IonSlides, IonSlide, IonContent, IonHeader, IonInput } from '@ionic/react';

import { ShowRoomPicsModal } from './Modal_ShowRoomPics';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import '../css/hotelCss.css';
import { UpdateCheckOutDateModal } from './Modal_Update_checkOutDate';
import { UpdateRoomModal } from './Modal_UpdateRoom';
import { ViewInvoiceModal } from '../../../zInternal_Features/merchant/components/Modal_ViewInvoice';

export function CheckedOutRoomDetailsModal(props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [startDate, setStartDate] = useState(new Date());
    let [endDate, setEndDate] = useState(new Date());
    let [numOfNights, setNumOfNights] = useState(0);

    let [roomPicsModal, setRoomPicsModal] = useState(false);

    let [numberOfNights, setDateRangeNumberOfNights] = useState(null);
    let [guestPayAmount, setGuestPayAmount] = useState(null);

    let [checkInInvoice_send, setCheckInInvoice_send] = useState(null);
    let [checkInInvoice_sent, setCheckInInvoice_sent] = useState(null);
    let [checkInInvoice_confirmPaid, setCheckInInvoice_confirmPaid] = useState(null);
        let [checkInInvoice_confirmPaid_non_member, setCheckInInvoice_confirmPaid_non_member] = useState(null);
    let [checkInInvoice_paid, setCheckInInvoice_paid] = useState(null);

    let [disablePayButton, setDisablePayButton] = useState(false);
    let [disableCheckOutButton, setDisableCheckOutButton] = useState(false);

    let [displaySetButton, setDisplaySetButton] = useState('inline-block');
    let [displayResetButton, setDisplayResetButton] = useState('none');
    let [disableSetButton, setDisableSetButton] = useState(false);
    let [disableResetButton, setDisableResetButton] = useState(false);

    let [viewInventoryOccupiedRoomDetailData, setViewInventoryOccupiedRoomDetailData] = useState([]);

    let [showInvoiceModal, setViewInvoiceModal] = useState(false);
    let [showUpdateCheckOutDateModal, setShowUpdateCheckOutDateModal] = useState(false);
    let [showUpdateRoomModal, setShowUpdateRoomModal] = useState(false);

    let [roomID, setRoomID] = useState(null);
    let [roomSalePrice, setRoomSalePrice] = useState(null);
    let [roomGuestInvoiceAttachment, setRoomGuestInvoiceAttachment] = useState(null);

    let enterPayRef = useRef(0);


   //getOccupiedRoomDetailData(instant_checkInRoomID) {
    useEffect(() => {

            /*
            let formData = new FormData();
            formData.append('Tracker', '74002I_Paid_In_Full_CheckOut');
            formData.append('user', acctID);
            formData.append('xCheckInRoomID', props.data.roomID);
            formData.append('xInvoiceID', props.data.merchantInvoiceID);
        
        
            const requestOptions = {
                enctype: 'multipart/form-data',
                method:'POST',
                credentials: 'include',
                files: formData,
                body: formData,
                contentType: false,
                processData: false,
            }
            */

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74002I_Paid_In_Full_CheckOut',
                    user: acctID,
                    xCheckInRoomID: props.data.roomID,
                    xInvoiceID: props.data.merchantInvoiceID,
                    sessionID: sessionID,
    
                }),
            }
        
            
            fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {
        
                let rows = res.toString().split('~~~');
        
                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');


                    let date1 = new Date(cols[20]);
                    let date2 = new Date(cols[21]);
                    let timeDiff;

                    if(date2.getDate() < date1.getDate())
                    {
                        if(date2.getMonth() == 3 || date2.getMonth() == 5 || date2.getMonth() == 8 || date2.getMonth() == 10)
                        {
                            if(date1.getMonth() == 3 || date1.getMonth() == 5 || date1.getMonth() == 8 || date1.getMonth() == 10)
                            {
                                timeDiff = Math.abs((date2.getDate() + 30) - date1.getDate());
                            }
                            else
                            {
                                timeDiff = Math.abs((date2.getDate() + 31) - date1.getDate());
                            }
                        }
                        else if(date2.getMonth() == 1)
                        {
                            if(date1.getMonth() == 3 || date1.getMonth() == 5 || date1.getMonth() == 8 || date1.getMonth() == 10)
                            {
                                timeDiff = Math.abs((date2.getDate() + 28) - date1.getDate());
                            }
                            else
                            {
                                timeDiff = Math.abs((date2.getDate() + 29) - date1.getDate());
                            }
                        }
                        else
                        {
                            //alert('In Get Dates');
                            //alert(date1.getDate());
                            //alert(date2.getDate());
                            if(date1.getMonth() == 3 || date1.getMonth() == 5 || date1.getMonth() == 8 || date1.getMonth() == 10)
                            {
                                timeDiff = Math.abs((date2.getDate() + 30) - date1.getDate());
                            }
                            else
                            {
                                timeDiff = Math.abs((date2.getDate() + 31) - date1.getDate());
                            }
                        }

                    }
                    else
                    {
                        timeDiff = Math.abs(date2.getDate() - date1.getDate());
                    }

                    if(date1.getDate() == date2.getDate())
                    {
                        setDateRangeNumberOfNights(1);
                        setGuestPayAmount(parseFloat(cols[19]*1).toFixed(2));
                    }
                    else
                    {
                        setDateRangeNumberOfNights(timeDiff);
                        setGuestPayAmount(parseFloat(cols[19]*timeDiff).toFixed(2));
    
                    }
        
                    if(cols[25] == 'N')
                    {
                        if(cols[29] == "C" && (parseFloat(cols[19]*timeDiff).toFixed(2) - parseFloat(cols[28]*1).toFixed(2)) == 0.00)
                        {
                            setCheckInInvoice_send('none');
                            setCheckInInvoice_sent('none');
                            setCheckInInvoice_confirmPaid('none');
                            setCheckInInvoice_confirmPaid_non_member('none');
                            setCheckInInvoice_paid('inline-block');
                        }
                        else if(cols[29] == "C" && (parseFloat(cols[19]*timeDiff).toFixed(2) - parseFloat(cols[28]*1).toFixed(2)) > 0.00)
                        {
                            setCheckInInvoice_send('inline-block');
                            setCheckInInvoice_confirmPaid_non_member('inline-block');
                            setCheckInInvoice_sent('none');
                            setCheckInInvoice_confirmPaid('none');
                            setCheckInInvoice_paid('none');
                        }
                        else
                        {
                            setCheckInInvoice_send('inline-block');
                                setCheckInInvoice_confirmPaid_non_member('inline-block');
                            setCheckInInvoice_sent('none');
                            setCheckInInvoice_confirmPaid('none');
                            setCheckInInvoice_paid('none');
                        }
        
                    }
                    
                    else if(cols[25] == 'PR')
                    {
                        setCheckInInvoice_send('none');
                        setCheckInInvoice_sent('inline-block');
                        setCheckInInvoice_confirmPaid('none');
                        setCheckInInvoice_paid('none');
        
                    }
                    else if(cols[25] == 'R_PC')
                    {
                        setCheckInInvoice_send('none');
                        setCheckInInvoice_sent('none');
                        setCheckInInvoice_confirmPaid('inline-block');
                        setCheckInInvoice_paid('none');
        
                    }
                    else if(cols[25] == 'C')
                    {
                        setCheckInInvoice_send('none');
                        setCheckInInvoice_sent('none');
                        setCheckInInvoice_confirmPaid('none');
                        setCheckInInvoice_confirmPaid_non_member('none');
                        setCheckInInvoice_paid('inline-block');
        
                    }

                    setViewInventoryOccupiedRoomDetailData((prevViewInventoryOccupiedRoomDetailData) => {
                        return prevViewInventoryOccupiedRoomDetailData.concat({
                            roomID: cols[0],
                            roomType: cols[1],
                            roomDescription: cols[2],
                            roomPartNum: cols[3],
                            roomPhoneNumber: cols[4],
                            address: cols[5],
                            city: cols[6],
                            country: cols[7],
                            roomSalePrice: parseFloat(cols[8]).toFixed(2),
                            roomPic1: cols[9],
                            roomPic2: cols[10],
                            roomPic3: cols[11],
                            roomPic4: cols[12],
                            attachment: cols[13],
                            roomGuestFirstName: cols[14],
                            roomGuestLastName: cols[15],
                            roomGuestPhoneNumber: cols[16],
                            roomGuestEmail: cols[17],
                            roomGuestPaymentType: cols[18],
                            roomGuestPrice: parseFloat(cols[19]).toFixed(2),
                            roomGuestCheckInDateBooked: cols[20],
                            roomGuestCheckOutDateBooked: cols[21],
                            roomGuestCheckInDateActual: cols[22],
                            merchantInvoiceID: cols[23],
                            customerInvoiceID: cols[24],
                            invoiceSentStatus: cols[25],
                            invoiceTotalAmount: cols[26],
                            transactionID: cols[27],
                            transactionTotalAmount: parseFloat(cols[28]*1).toFixed(2),
                            transactionStatus: cols[29],
                            roomGuestInvoiceAttachment: cols[30],
                        })

                    });
        
                }    
            })
    }, []);

    function sendToCustomer(event)
    {
        /*
        let formData = new FormData();
        formData.append('Tracker', 74108);
        formData.append('user', acctID);
        formData.append('xQavaMemberID', event[2]);
        formData.append('xInvoiceID', event[0]);
        formData.append('xCustomerInvoiceID', event[1]);

        const requestOptions = {
            //enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            body: formData
        }
        */
        
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74108',
                user: acctID,
                xQavaMemberID: event[2],
                xInvoiceID: event[0],
                xCustomerInvoiceID: event[1],
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            //alert(data);
            let cols = data.toString().split('|');
            //alert(cols[0]);
            //alert(cols[1]);


            if(cols[0] == 'sent1' && cols[1] == 'inserted1')
            {

                setCheckInInvoice_send('none');
                setCheckInInvoice_sent('inline-block');
                setCheckInInvoice_confirmPaid('none');
                setCheckInInvoice_paid('none');

                alert('Invoice Sent to ' + event[2] + 'Ad Hoc.');
            }
            else
            {
                alert('Sent transaction incomplete');
            }
        })
        .catch(error => {
            console.error(error);
        })
    }

    function confirmPayment(event)
    {
        let tracker = event[3];
        let customerInvoiceID = event[1];
        let transactionID = event[0];
        let customerPhoneNumber = event[2];

        /*
        let formData = new FormData();
        formData.append('Tracker', tracker);
        formData.append('xCustomerInvoiceID', customerInvoiceID);
        formData.append('xTransactionID', transactionID);
        formData.append('xCustMobileNumber', customerPhoneNumber);
        formData.append('user', acctID);

        const requestOptions = {
            method:'POST',
            credentials: 'include',
            body: formData
        }
        */
                
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: tracker,
                user: acctID,
                xCustomerInvoiceID: customerInvoiceID,
                xTransactionID: transactionID,
                xCustMobileNumber: customerPhoneNumber,
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            if (data == 'confirmed')
            {
                /*document.getElementById(transactionID + 'pc').style.display = 'none';
                document.getElementById(transactionID + 'pr').style.display = 'none';
                document.getElementById(transactionID + 'c').style.display = 'inline-block';
                document.getElementById(transactionID + 'r').style.display = 'none';*/
                setCheckInInvoice_send('none');
                setCheckInInvoice_sent('none');
                setCheckInInvoice_confirmPaid('none');
                setCheckInInvoice_paid('inline-block');

                alert('Client Payment Confirmed');
                //this.updateShowOccupiedRooms(false);
                //this.updateOccupiedRoomDetailsModal(false);
            }
            else
            {
                /*document.getElementById(transactionID + 'pc').style.display = 'inline-block';
                document.getElementById(transactionID + 'pr').style.display = 'inline-block';
                document.getElementById(transactionID + 'c').style.display = 'none';
                document.getElementById(transactionID + 'r').style.display = 'inline-block';*/

                setCheckInInvoice_send('none');
                setCheckInInvoice_sent('none');
                setCheckInInvoice_confirmPaid('inline-block');
                setCheckInInvoice_paid('none');

                alert('Error confirming payment');
                //this.updateShowOccupiedRooms(false);
                //this.updateOccupiedRoomDetailsModal(false);
            }
        })
    }

    function prepareInvoice_thenConfirmPay_nonMember(event)
    {
        //alert('In Confirm non_member_payment prep');
        //alert(event[5]);
        setDisablePayButton(true);

        /*
        let formData = new FormData();
        formData.append('Tracker', '74108_B');
        formData.append('user', acctID);
        formData.append('xCustMobileNumber', event[3]);
        formData.append('xInvoiceID', event[1]);
        formData.append('xCustomerInvoiceID', event[2]);
        formData.append('xImmediateDestination', acctID);
        formData.append('xCheckInCashAmount', parseFloat(event[5]).toFixed(2));


        const requestOptions = {
            //enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            body: formData
        }
        */

        
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74108_B',
                user: acctID,
                xCustMobileNumber: event[3],
                xInvoiceID: event[1],
                xCustomerInvoiceID: event[2],
                xImmediateDestination: acctID,
                xCheckInCashAmount: parseFloat(event[5]).toFixed(2),
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            //alert('Confirming Transaction ID -'+data);

            confirmPayment_non_member([data, event[1], event[2], event[3], event[4], event[6]]);


            /*let cols = data.toString().split('|');


            if(cols[0] == 'prepared1')
            {

                //setCheckInInvoice_send('none');
                //setCheckInInvoice_sent('inline-block');
                //setCheckInInvoice_confirmPaid('none');
                //setCheckInInvoice_paid('none');

                alert('Invoice Prepared for ' + event[2] + 'Ad Hoc.');

            }
            else
            {
                alert('Prepare Invoice incomplete');
            }*/
        })
        .catch(error => {
            console.error(error);
        })
    }

    function confirmPayment_non_member(event)
    {

        let tracker = event[4];
        let customerInvoiceID = event[2];
        let transactionID = event[0];
        let customerPhoneNumber = event[3];

        /*
        let formData = new FormData();
        formData.append('Tracker', tracker);
        formData.append('xCustomerInvoiceID', customerInvoiceID);
        formData.append('xTransactionID', transactionID);
        formData.append('xCustMobileNumber', customerPhoneNumber);
        formData.append('user', acctID);
        formData.append('xCheckInRoomID', event[5]);

        const requestOptions = {
            method:'POST',
            credentials: 'include',
            body: formData
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: tracker,
                user: acctID,
                xCustomerInvoiceID: customerInvoiceID,
                xTransactionID: transactionID,
                xCustMobileNumber: customerPhoneNumber,
                xCheckInRoomID: event[5],
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            if (data == 'confirmed')
            {
                /*document.getElementById(transactionID + 'pc').style.display = 'none';
                document.getElementById(transactionID + 'pr').style.display = 'none';
                document.getElementById(transactionID + 'c').style.display = 'inline-block';
                document.getElementById(transactionID + 'r').style.display = 'none';*/
                setCheckInInvoice_send('none');
                setCheckInInvoice_sent('none');
                setCheckInInvoice_confirmPaid('none');
                setCheckInInvoice_confirmPaid_non_member('none');
                setCheckInInvoice_paid('inline-block');

                alert('Client Payment Confirmed');
                //this.updateShowOccupiedRooms(false);
                //this.updateOccupiedRoomDetailsModal(false);
            }
            else if(data == 'confirmed_partial')
            {

                setCheckInInvoice_send('none');
                setCheckInInvoice_sent('none');
                setCheckInInvoice_confirmPaid('none');
                setCheckInInvoice_confirmPaid_non_member('inline-block');
                setCheckInInvoice_paid('none');

                alert('Client Partial Payment Confirmed');

            }
            else
            {
                /*document.getElementById(transactionID + 'pc').style.display = 'inline-block';
                document.getElementById(transactionID + 'pr').style.display = 'inline-block';
                document.getElementById(transactionID + 'c').style.display = 'none';
                document.getElementById(transactionID + 'r').style.display = 'inline-block';*/

                setCheckInInvoice_send('none');
                setCheckInInvoice_sent('none');
                setCheckInInvoice_confirmPaid('none');
                setCheckInInvoice_paid('none');

                alert('Error confirming payment');
                //this.updateShowOccupiedRooms(false);
                //this.updateOccupiedRoomDetailsModal(false);
            }
        })
    }

    function setPayHandler()
    {
        setDisableSetButton(true);
        setDisplaySetButton('none');
        setDisableResetButton(false);
        setDisplayResetButton('inline-block');

    }

    function resetPayHandler()
    {
        setDisableResetButton(true);
        setDisplayResetButton('none');
        enterPayRef.current.value = '';
        setDisableSetButton(false);
        setDisplayResetButton('none');
        setDisplaySetButton('inline-block');
    }

    function handleUpdate_checkOutDate(event)
    {

        setStartDate(event[1]);
        setEndDate(event[2]);
        setShowUpdateCheckOutDateModal(event[0]);
    }

    function handleUpdate_room(event)
    {

        setStartDate(event[1]);
        setEndDate(event[2]);
        setShowUpdateRoomModal(event[0]);
    }

    function onSubmitNewDateHandler(e)
    {

        //alert('In BEGINNING onSubmitNewDateHandler');

        setViewInventoryOccupiedRoomDetailData([]);

        let date1 = new Date(new Date(startDate.toLocaleString('en-US', {timeZone: 'Greenwich Mean Time',})));
        let date2 = e[1];
        let timeDiff;

        if(date2.getDate() < date1.getDate())
        {
            if(date2.getMonth() == 3 || date2.getMonth() == 5 || date2.getMonth() == 8 || date2.getMonth() == 10)
            {
                if(date1.getMonth() == 3 || date1.getMonth() == 5 || date1.getMonth() == 8 || date1.getMonth() == 10)
                {
                    timeDiff = Math.abs((date2.getDate() + 30) - date1.getDate());
                }
                else
                {
                    timeDiff = Math.abs((date2.getDate() + 31) - date1.getDate());
                }
            }
            else if(date2.getMonth() == 1)
            {
                if(date1.getMonth() == 3 || date1.getMonth() == 5 || date1.getMonth() == 8 || date1.getMonth() == 10)
                {
                    timeDiff = Math.abs((date2.getDate() + 28) - date1.getDate());
                }
                else
                {
                    timeDiff = Math.abs((date2.getDate() + 29) - date1.getDate());
                }
            }
            else
            {
                //alert('In Get Dates');
                //alert(date1.getDate());
                //alert(date2.getDate());
                if(date1.getMonth() == 3 || date1.getMonth() == 5 || date1.getMonth() == 8 || date1.getMonth() == 10)
                {
                    timeDiff = Math.abs((date2.getDate() + 30) - date1.getDate());
                }
                else
                {
                    timeDiff = Math.abs((date2.getDate() + 31) - date1.getDate());
                }
            }

        }
        else
        {
            timeDiff = Math.abs(date2.getDate() - date1.getDate());
        }

        //alert('In onSubmitNewDateHandler');
        //alert(e);
        //alert(date1);
        //alert(date2);
        //alert(calcNumberOfNights);

        setStartDate(date1);
        setEndDate(date2);
        setDateRangeNumberOfNights(timeDiff);


        /*
        let formData = new FormData();
        formData.append('Tracker', '74112_U_OUT');
        formData.append('user', acctID);
        formData.append('xCheckInRoomID', props.data.roomID);
        formData.append('xStartDateRange', date1.toISOString().substr(0, 10));
        formData.append('xEndDateRange', date2.toISOString().substr(0, 10));
        formData.append('xCheckInNumberOfNights', timeDiff);


        const requestOptions = {
            //enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            body: formData
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74112_U_OUT',
                user: acctID,
                xCheckInRoomID: props.data.roomID,
                xStartDateRange: date1.toISOString().substr(0, 10),
                xEndDateRange: date2.toISOString().substr(0, 10),
                xCheckInNumberOfNights: timeDiff,
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            let rows = data.toString().split('~~~');
        
            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');

                let date1 = new Date(cols[22]);
                let date2 = new Date(cols[21]);
                let timeDiff;

                if(date2.getDate() < date1.getDate())
                {
                    if(date2.getMonth() == 3 || date2.getMonth() == 5 || date2.getMonth() == 8 || date2.getMonth() == 10)
                    {
                        if(date1.getMonth() == 3 || date1.getMonth() == 5 || date1.getMonth() == 8 || date1.getMonth() == 10)
                        {
                            timeDiff = Math.abs((date2.getDate() + 30) - date1.getDate());
                        }
                        else
                        {
                            timeDiff = Math.abs((date2.getDate() + 31) - date1.getDate());
                        }
                    }
                    else if(date2.getMonth() == 1)
                    {
                        if(date1.getMonth() == 3 || date1.getMonth() == 5 || date1.getMonth() == 8 || date1.getMonth() == 10)
                        {
                            timeDiff = Math.abs((date2.getDate() + 28) - date1.getDate());
                        }
                        else
                        {
                            timeDiff = Math.abs((date2.getDate() + 29) - date1.getDate());
                        }
                    }
                    else
                    {
                        //alert('In Get Dates');
                        //alert(date1.getDate());
                        //alert(date2.getDate());
                        if(date1.getMonth() == 3 || date1.getMonth() == 5 || date1.getMonth() == 8 || date1.getMonth() == 10)
                        {
                            timeDiff = Math.abs((date2.getDate() + 30) - date1.getDate());
                        }
                        else
                        {
                            timeDiff = Math.abs((date2.getDate() + 31) - date1.getDate());
                        }
                    }

                }
                else
                {
                    timeDiff = Math.abs(date2.getDate() - date1.getDate());
                }

                if(date1.getDate() == date2.getDate())
                {
                    setDateRangeNumberOfNights(1);
                    setGuestPayAmount(parseFloat(cols[19]*1).toFixed(2));
                }
                else
                {
                    setDateRangeNumberOfNights(timeDiff);
                    setGuestPayAmount(parseFloat(cols[19]*timeDiff).toFixed(2));

                }

                setViewInventoryOccupiedRoomDetailData((prevViewInventoryOccupiedRoomDetailData) => {
                    return prevViewInventoryOccupiedRoomDetailData.concat({
                        roomID: cols[0],
                        roomType: cols[1],
                        roomDescription: cols[2],
                        roomPartNum: cols[3],
                        roomPhoneNumber: cols[4],
                        address: cols[5],
                        city: cols[6],
                        country: cols[7],
                        roomSalePrice: parseFloat(cols[8]).toFixed(2),
                        roomPic1: cols[9],
                        roomPic2: cols[10],
                        roomPic3: cols[11],
                        roomPic4: cols[12],
                        attachment: cols[13],
                        roomGuestFirstName: cols[14],
                        roomGuestLastName: cols[15],
                        roomGuestPhoneNumber: cols[16],
                        roomGuestEmail: cols[17],
                        roomGuestPaymentType: cols[18],
                        roomGuestPrice: parseFloat(cols[19]).toFixed(2),
                        roomGuestCheckInDateBooked: new Date(cols[20]).toISOString().substr(0, 10),
                        roomGuestCheckOutDateBooked: new Date(cols[21]).toISOString().substr(0, 10),
                        roomGuestCheckInDateActual: new Date(cols[22]).toISOString().substr(0, 10),
                        merchantInvoiceID: cols[23],
                        customerInvoiceID: cols[24],
                        invoiceSentStatus: cols[25],
                        invoiceTotalAmount: cols[26],
                        transactionID: cols[27],
                        transactionTotalAmount: parseFloat(cols[28]*1).toFixed(2),
                        transactionStatus: cols[29],
                        roomGuestInvoiceAttachment: cols[30],
                    })

                });
            }

            alert('Room Check-Out Date Has been updated to '+e);

            props.closeModal();

        })
        .catch(error => {
            console.error(error);
        })

    }

    function checkOutGuest(event)
    {
        setDisableCheckOutButton(true);

        /*
        let formData = new FormData();
        formData.append('Tracker', 74125);
        formData.append('user', acctID);
        formData.append('xCheckInRoomID', event[0]);
        formData.append('xCustomerInvoiceID', event[1]);

        const requestOptions = {
            //enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            body: formData
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74125',
                user: acctID,
                xCheckInRoomID: event[0],
                xCustomerInvoiceID: event[1],
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            //alert(data);
            let cols = data.toString().split('|');
            //alert(cols[0]);
            //alert(cols[1]);


            if(cols[0] == 'checked_out')
            {            
                alert('Room ' + event[0] + 'Successfully Checked out');

                props.closeModal(false);

            }
            else
            {
                alert('Room Checkout Unsuccessful');
            }
        })
        .catch(error => {
            console.error(error);
        })
    }

    function viewInvoiceModalHandler(event) {


        setRoomID(event[1]);
        setRoomSalePrice(event[2]);
        setRoomGuestInvoiceAttachment(event[3]);
        setViewInvoiceModal(event[0]);

    }

    function closeModalHandler() {

        setViewInventoryOccupiedRoomDetailData([]);
        props.closeModal(false);
    }

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
        <IonHeader className='grid_checkInHeader'>
            <IonGrid class='gridModalTopInfo'>
                    <IonRow>
                        <IonCol> Room ID</IonCol>
                        <IonCol> Price Per Night</IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol> {props.data.roomID} </IonCol>
                        <IonCol> {props.data.roomSalePrice} </IonCol>
                    </IonRow>
            </IonGrid>
        </IonHeader>
        <IonContent className='occupiedDetails_gridContent'>

            {viewInventoryOccupiedRoomDetailData.map((detailData) =>   {
            return (
            <IonGrid class='gridText'>
                <IonRow class='gridResultHeaders'>
                    <IonCol size='3' class='gridResultColumns'>Category</IonCol>
                    <IonCol size='6'class='gridResultColumns'>Value</IonCol>
                    <IonCol size='3' class='gridResultColumns'>Action</IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol size='3' class='gridResultHeaders'> Invoice ID </IonCol>
                    <IonCol size='6' class='gridResultColumns'>{detailData.merchantInvoiceID}</IonCol>
                    <IonCol size='3' class='gridResultColumns'>
                        <IonButton class='gridResultColumnButton' onClick={() => viewInvoiceModalHandler([true, detailData.roomID, detailData.roomSalePrice, detailData.roomGuestInvoiceAttachment])}> View </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol size='3' class='gridResultHeaders'>Change Room</IonCol>
                    <IonCol size='6' class='gridResultColumns'>{ 'ID: '+detailData.roomID+
                                                        'Part #: '+detailData.roomPartNum}</IonCol>
                    <IonCol size='3' class='gridResultColumns'>
                        <IonButton onClick={() => handleUpdate_room([true, detailData.roomGuestCheckInDateActual, detailData.roomGuestCheckOutDateBooked])} class='gridResultColumnButton'> Update </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol size='3' class='gridResultHeaders'>Room Images</IonCol>
                    <IonCol size='6' class='gridResultColumns'>{detailData.roomType}</IonCol>
                    <IonCol size='3' class='gridResultColumns'>
                        <ShowRoomPicsModal openModal={ roomPicsModal } closeModal={() => setRoomPicsModal(false)} data={{
                        roomPic1: detailData.roomPic1, 
                        roomPic2: detailData.roomPic2, 
                        roomPic3: detailData.roomPic3, 
                        roomPic4: detailData.roomPic4, 
                        roomID: detailData.roomID, 
                        roomSalePrice: detailData.roomSalePrice
                        }}></ShowRoomPicsModal>
                        <IonButton class='gridResultColumnButton' onClick={() => setRoomPicsModal(true)}> View </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol size='3' class='gridResultHeaders'>Check-In Date</IonCol>
                    <IonCol size='6' class='gridResultColumns'>{detailData.roomGuestCheckInDateActual}</IonCol>
                    <IonCol size='3' class='gridResultColumns'>
                        <IonButton class='gridResultColumnButton'> - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol size='3' class='gridResultHeaders'>Check-Out Date</IonCol>
                    <IonCol size='6' class='gridResultColumns'>{detailData.roomGuestCheckOutDateBooked}</IonCol>
                    <IonCol size='3' class='gridResultColumns'>
                        <IonButton onClick={() => handleUpdate_checkOutDate([true, detailData.roomGuestCheckInDateBooked, detailData.roomGuestCheckOutDateBooked])} class='gridResultColumnButton'> Update </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol size='3' class='gridResultHeaders'># of Nights</IonCol>
                    <IonCol size='6' class='gridResultColumns'>{numberOfNights}</IonCol>
                    <IonCol size='3' class='gridResultColumns'>
                        <IonButton class='gridResultColumnButton'> - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol size='3' class='gridResultHeaders'>Guest Contact</IonCol>
                    <IonCol size='6' style={{fontSize: 'small'}}>{ 'Name: '+detailData.roomGuestFirstName+' '+detailData.roomGuestLastName+
                                                        ', Phone #: '+detailData.roomGuestPhoneNumber+
                                                        ', Email: '+detailData.roomGuestEmail}</IonCol>
                    <IonCol size='3' class='gridResultColumns'>
                        <IonButton class='gridResultColumnButton'> - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol size='3' class='gridResultHeaders'>Guest Room Price</IonCol>
                    <IonCol size='6' class='gridResultColumns'>{detailData.roomGuestPrice}</IonCol>
                    <IonCol size='3' class='gridResultColumns'>
                        <IonButton class='gridResultColumnButton'> - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol size='3' class='gridResultHeaders'>Guest Payment Type</IonCol>
                    <IonCol size='6' class='gridResultColumns'>{detailData.roomGuestPaymentType}</IonCol>
                    <IonCol size='3' class='gridResultColumns'>
                        <IonButton class='gridResultColumnButton'> - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol size='3' class='gridResultHeaders'>Amount Paid</IonCol>
                    <IonCol size='6' class='gridResultColumns'>{detailData.transactionTotalAmount}</IonCol>
                    <IonCol size='3' class='gridResultColumns'>
                        <IonButton class='gridResultColumnButton' > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol size='3' class='gridResultHeaders'>Balance</IonCol>
                    <IonCol size='6' class='gridResultColumns'>{parseFloat(guestPayAmount - detailData.transactionTotalAmount).toFixed(2)}</IonCol>
                    <IonCol size='3' class='gridResultColumns'>
                        <IonButton class='gridResultColumnButton' > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol size='3' class='gridResultHeaders'>Pay</IonCol>
                    <IonCol size='3'>
                        <IonInput style={{display: displaySetButton}} type='number' placeholder='Enter %' ref={enterPayRef}></IonInput>
                        <h4 style={{display: displayResetButton}}>{enterPayRef.current.value+' GH'}</h4>
                    </IonCol>
                    <IonCol size='3'>
                        <IonButton style={{display: displaySetButton}} disabled={disableSetButton} onClick={() => setPayHandler()}>Set</IonButton>
                        <IonButton style={{display: displayResetButton}} disabled={disableResetButton} onClick={() => resetPayHandler()}>Reset</IonButton>
                    </IonCol>
                    <IonCol size='3' class='gridResultColumns'>
                        {authenticatedMerchent_context.accessRights[0] == 'admin' && <IonButton class='gridResultColumnButton' style={{display: checkInInvoice_send}} onClick={() => sendToCustomer([detailData.merchantInvoiceID, detailData.customerInvoiceID, detailData.roomGuestPhoneNumber])}> Send Invoice </IonButton>}
                        <IonButton class='gridResultColumnButton' style={{display: checkInInvoice_sent}} > Pending Payment/View Sent </IonButton>
                        {authenticatedMerchent_context.accessRights[0] == 'admin' && <IonButton class='gridResultColumnButton' style={{display: checkInInvoice_confirmPaid}} onClick={() => confirmPayment([detailData.transactionID, detailData.customerInvoiceID, detailData.roomGuestPhoneNumber, '74605'])}> Pay Member </IonButton>}
                        {authenticatedMerchent_context.accessRights[0] == 'admin' && <IonButton id='gridResultColumnButton' disabled={disablePayButton} style={{display: checkInInvoice_confirmPaid_non_member}} onClick={() => prepareInvoice_thenConfirmPay_nonMember([detailData.transactionID, detailData.merchantInvoiceID, detailData.customerInvoiceID, detailData.roomGuestPhoneNumber, '74605_B_Checked_Out', enterPayRef.current.value, detailData.roomID])}> Pay</IonButton>}
                        <p class='gridResultColumnButton' style={{display: checkInInvoice_paid}}> Payment Confirmed </p>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol size='3' class='gridResultHeaders'>Check-Out Guest</IonCol>
                    <IonCol size='6' class='gridResultColumns'>{'Name: '+detailData.roomGuestFirstName+' '+detailData.roomGuestLastName}</IonCol>
                    <IonCol size='3' class='gridResultColumns'>
                        <p class='gridResultColumnButton' style={{display: checkInInvoice_confirmPaid_non_member}}> Need To Pay </p>
                        <IonButton class='gridResultColumnButton' disabled={disableCheckOutButton} style={{display: checkInInvoice_paid}} onClick={() => checkOutGuest([detailData.roomID, detailData.customerInvoiceID])}> Check-Out </IonButton>
                    </IonCol>
                </IonRow>
                {authenticatedMerchent_context.accessRights[0] == 'admin' &&
                <IonRow class='gridResultBody'>
                    <IonCol size='3' class='gridResultHeaders'>FORCE Check-Out</IonCol>
                    <IonCol size='6' class='gridResultColumns'>{'Name: '+detailData.roomGuestFirstName+' '+detailData.roomGuestLastName}</IonCol>
                    <IonCol size='3' class='gridResultColumns'>
                        <IonButton class='gridResultColumnButton' disabled={disableCheckOutButton} onClick={() => checkOutGuest([detailData.roomID, detailData.customerInvoiceID])}> Check-Out </IonButton>
                    </IonCol>
                </IonRow>}
            </IonGrid>
                    )
                }
            )}

        </IonContent>

        {showInvoiceModal == true && <ViewInvoiceModal openModal={ showInvoiceModal } closeModal={() => setViewInvoiceModal(false)} data={{
                                        fileLocation: roomGuestInvoiceAttachment, 
                                        roomID: roomID, 
                                        roomSalePrice: roomSalePrice,
                                        }}></ViewInvoiceModal>}

        {showUpdateCheckOutDateModal == true && <UpdateCheckOutDateModal openModal={ showUpdateCheckOutDateModal } closeModal={() => setShowUpdateCheckOutDateModal(false)} onSubmitNewDate={onSubmitNewDateHandler}></UpdateCheckOutDateModal>}

        {showUpdateRoomModal == true && <UpdateRoomModal openModal={ showUpdateRoomModal } closeModal={() => setShowUpdateRoomModal(false)} startDate={new Date(startDate).toISOString().substr(0, 10)} endDate={new Date(endDate).toISOString().substr(0, 10)} currentRoom={props.data.roomID}></UpdateRoomModal>}

        <IonButton className='button_closeModal_center' onClick={() => closeModalHandler()}> Close </IonButton>

    </IonModal>) : null}
    </React.Fragment>
    )
}